import { useParams } from "react-router-dom"
import { ProjectNeedSlotsManager } from "../ProjectNeedSlotsManager"

export const EditWhatNeededForm = () => {
    const { id } = useParams<{ id: string }>()
    const projectId = id ? parseInt(id, 10) : NaN

    return (
        <ProjectNeedSlotsManager
            projectId={projectId}
            kind="resource"
            title="Ресурсы"
        />
    )
}
